import Routes from 'Routes';
import { filterPsgName } from '@csair/emp-helpers';
import { isOfficialTicket } from 'Utils';
import {
  CHECK_TICKET,
  CHECK_TICKET_FLIGHT,
  SAVE_CHANGE_PROCESS,
  CLEAR_TICKET_INFO,
  REPLACE_FLIGHT,
  SAVE_X_PRODUCTS,
  SAVE_PSG_FLIGHT,
  SAVE_MU_TYPE,
  SAVE_HU_TYPE,
  SAVE_AI_PRAMAS,
  SAVE_DOOR_PRODUCTS,
  SAVE_MU_FILE,
  SAVE_HU_FILE,
} from './actions';

const initialState = {
  orderNo: '', // 订单号
  ticketNo: '', // 票号
  salechannel: '', // 客票销售渠道
  ticketClass: 'default', // 客票类型 Group团体 DK DynamicMileage动态里程 StaticMileage固定里程（价格都按现金展示）MixinsMileage(混合支付里程) Civil公务 BonusPoints 积分票 Mix 混合支付票 DXFULLPKX 大兴全价票 DXAWARDPKX 大兴奖励票 ZDHK-TICK 中段换开客票 Government 政府采购机票
  ticketType: 'd', // o公务票 m里程客票(动态里程) m1固定里程 d普通客票(默认) 废弃请使用ticketClass
  refundMethod: '', // 退票方式 退票：e2e 预约退票：book
  isDomestic: true, // 是否是国内票
  isExchanged: false, // 是否换开
  flightList: [], // 航段
  psgList: [], // 乘机人
  changeProcess: [], // 变更流程类型(每次步骤操作修改变更流程类型，最后会剩下一种类型)
  artificialVerify: '', // 变更是否走人工审核
  flightRules: {}, // 每个航段变更日期限制 eg: { 1: [{ ticketNo, changeFlightDateRule }] }
  // x产品，关联变动判断逻辑请参考 EndorsedApply/index.js/relatedXproducts
  isEpidemicPolicy: false, // 是否疫情政策(zybg符合疫情政策走非自愿屏蔽降舱校验)
  xProduct: {
    flightProductId: '',
    products: [],
    xSoProducts: {},
    trainProduct: [],
    airProductId: '',
    hotelProduct: [],
    trainCoupon: [],
    trainPro: [],
  },
  orderSoDetail: {},
  goOrder: '', // GO单号
  // isJXflight:false  // 是否是吉祥航空的客票
  exchangeType: '',
  currency: '',
  b2bFlag: false, //B2B客票
  campaignScriptId: '', //竞价候补
  bankGateWayCode: '', //优惠券参数
  getTicketCoupon: '',
  soProMessage: '',
  isCeAirline: '',
  iataOrderViewRS: {}, //东航数据
  muRefundType: '',
  huRefundType: '',
  muFileList: [],
  muRefundReason: '',
  muTicketFlights: {},
  muChangeNo: '',
  receivableCoupons: [],
  iataOrderViewRSHU: {},
  iataOrderViewRSCA: {}, // 国航数据
  hotelSummary: '',
  airportTransferList: [],
  selectDoorList: [],
  qtReason: '',
  sellerId: '',
  beizhu: '',
  huFileList: [],
  huRefundReason: '',
};
let isEN = window.sessionStorage.getItem('language') == 'en';
function transCabin(name) {
  switch (name) {
    case '经济舱':
      return 'Economy Class';
    case '明珠经济舱':
      return 'Sky Pearl Economy Class';
    case '公务舱':
      return 'Business Class';
    case '头等舱':
      return 'First Class';
    default:
      return name;
      break;
  }
}
export default function EdorsedApplyReducer(state = initialState, action) {
  try {
    switch (action.type) {
      case `${CHECK_TICKET}_SUCCESS`:
        const {
          payload: {
            data: {
              ticketFlights,
              ticketType,
              checkResult,
              refundType,
              isExchanged,
              orderDetailVo,
              orderSoDetailVO,
              gloOrederVo,
              bankGateWayCode,
              getCoupon,
              soMessage,
              isCeAirline,
              iataOrderViewRS,
              receivableCoupons,
              iataOrderViewRSCA,
              order,
              hotelSummary,
              airportTransferList,
              dataLists,
              sellerId,
            },
          },
          meta: {
            previousAction: { ticketNo },
          },
        } = action;
        let _ticketType;

        if (
          (checkResult === 'Y' || checkResult === 'S') &&
          window.location.href.indexOf(
            Routes.ticket.child.updateDetail.path
          ) === -1
        ) {
          if (ticketFlights.isMileage === 'Y0') {
            // Y0动态里程，按照之前的里程流程逻辑
            _ticketType = 'm';
          } else if (ticketFlights.isMileage === 'Y1') {
            // 固定里程，新航班按价格的展示
            _ticketType = 'm1';
          } else if (isOfficialTicket(ticketFlights.psgList)) {
            _ticketType = 'o';
          } else {
            _ticketType = 'd';
          }

          let _xProduct = {
            flightProductId: '',
            products: [],
            xSoProducts: {},
            trainProduct: [],
            airProductId: '',
            hotelProduct: [],
            trainCoupon: [],
          };
          let orderSoDetail = {};

          ticketFlights.psgList = ticketFlights.psgList.map(function (item) {
            item.XNos = [];
            return item;
          });
          if (orderDetailVo && refundType !== 'e2e') {
            const { airTicket, xproductVOs } = orderDetailVo;
            _xProduct.flightProductId = airTicket.productId || '';
            // 关联变动判断逻辑请参考 EndorsedApply/index.js/relatedXproducts
            _xProduct.products = (xproductVOs || []).map(item => ({
              text: item.productZhName,
              type: 'num',
              min: 0, // 最小值，默认0，realSegOrder与航段关联变动
              max: item.max || 0, // 最大值，realSegOrder与航段关联变动
              linkMax: item.max || 0, // 强关联最大值
              linkValue: item.min || 0, // 强关联最小值
              value: item.max || 0, // 当前值，默认最大值
              unit: '张',
              realSegOrder: item.realSegOrder, // 与航段segmentId存在关联关系
              details: item.xproductDetails
                .map(detailItem => ({
                  productId: detailItem.productId,
                  segOrder: detailItem.segOrder,
                  realSegOrder: detailItem.realSegOrder,
                  highRelevancy: detailItem.highRelevancy,
                  orderNo: detailItem.orderNo,
                  subGoodsId: detailItem.subgoodsid,
                  subGoodsZhName: detailItem.subgoodsZhName,
                  psgObj: detailItem.xpassenger,
                  isSele: detailItem.highRelevancy ? false : true,
                }))
                .sort(detailItem => (detailItem.highRelevancy ? -1 : 1)),
            }));
            xproductVOs.forEach(item => {
              item.xproductDetails.forEach(ite => {
                ticketFlights.psgList.forEach(iu => {
                  if (
                    iu.psgName == ite.xpassenger.name &&
                    iu.certificateIdDis == ite.xpassenger.number &&
                    ite.highRelevancy
                  ) {
                    iu.XNos.push(ite.orderNo);
                  }
                });
              });
            });

            let arr = [];
            const psgArr = ticketFlights.psgList
              .map((item, i) => (item.valid ? i : ''))
              .filter(item => item !== '');
            if (psgArr.length === 1) arr = psgArr;
            arr.forEach(item => {
              ticketFlights.psgList[item].XNos.forEach(it => {
                _xProduct.products.forEach(io => {
                  io.details.forEach(ip => {
                    if (ip.orderNo == it) {
                      ip.isSele = true;
                    }
                  });
                });
              });
            });
            _xProduct.products.forEach(item => {
              let heightNum = item.details.filter(iu => {
                return !iu.isSele && iu.highRelevancy;
              }).length;
              let minheightNum = item.details.filter(iu => {
                return iu.isSele && iu.highRelevancy;
              }).length;
              item.value = item.details.length - heightNum;
              item.linkValue = minheightNum;
              item.max = item.details.length - heightNum;
              item.min = minheightNum;
              item.show = item.details.every(nb => {
                return nb.highRelevancy;
              });
            });
          }

          // so产品
          if (
            orderSoDetailVO &&
            orderSoDetailVO !== null &&
            refundType !== 'e2e'
          ) {
            const {
              xsoProductVOs,
              xairIronTransportVO,
              airTicketProductId,
              orderDetailHT,
              airIronTransportDiscounts,
            } = orderSoDetailVO;
            if (xsoProductVOs !== null && xsoProductVOs) {
              _xProduct.xSoProducts = xsoProductVOs;
            }

            if (xairIronTransportVO !== null && xairIronTransportVO) {
              _xProduct.airProductId = airTicketProductId;
              _xProduct.trainProduct = xairIronTransportVO;
            }

            if (airIronTransportDiscounts) {
              _xProduct.airProductId = airTicketProductId;
              _xProduct.trainCoupon = airIronTransportDiscounts;
            }

            // 酒店产品
            if (orderDetailHT !== null && orderDetailHT) {
              _xProduct.hotelProduct = orderDetailHT;
            }

            orderSoDetail = orderSoDetailVO;
          }

          if (ticketType === 'ZDHK-TICK') {
            ticketFlights.psgList.forEach(item => {
              item.scopeCodes = ['fzybg'];
            });
          }
          return Object.assign({}, state, {
            ticketType: _ticketType ? _ticketType : 'd',
            ticketClass: ticketType,
            flightList: ticketFlights.flightList.map(item => {
              item.flightNo = /[a-z]/i.test(item.flightNo)
                ? item.flightNo
                : item.carrier + item.flightNo;
              item.flightClass = isEN
                ? transCabin(item.flightClass)
                : item.flightClass;
              return item;
            }),
            psgList: ticketFlights.psgList.map(item => {
              item._psgName = filterPsgName(item.psgName, item.psgType);
              // item._psgName = filterPsgName(item.psgName, item.psgType);
              item._valid = true;
              return item;
            }),
            salechannel: ticketFlights.salechannel,
            orderNo: ticketFlights.orderNo || '',
            muChangeNo: ticketFlights.changeNo || '',
            refundMethod: refundType,
            isDomestic: ticketFlights.psgList[0].domestic !== 1,
            isExchanged: isExchanged === '1',
            ticketNo: ticketNo || '',
            xProduct: _xProduct,
            goOrder: gloOrederVo,
            currency: ticketFlights.currency,
            orderSoDetail: orderSoDetail,
            b2bFlag: ticketFlights.b2bFlag,
            campaignScriptId: ticketFlights.campaignScriptId,
            bankGateWayCode: bankGateWayCode,
            getTicketCoupon: getCoupon,
            soProMessage: soMessage,
            isCeAirline,
            iataOrderViewRS,
            iataOrderViewRSCA,
            iataOrderViewRSHU: { order: order, dataLists: dataLists },
            muTicketFlights: ticketFlights,
            receivableCoupons,
            hotelSummary: hotelSummary,
            airportTransferList,
            sellerId,
            // isJXflight:true
          });
        }
        return state;
      case `${CHECK_TICKET_FLIGHT}_SUCCESS`:
        const {
          payload: { data },
        } = action;
        if (data.refundType)
          return Object.assign({}, state, {
            refundMethod: data.refundType,
          });
        return state;
      case CLEAR_TICKET_INFO:
        return initialState;
      case SAVE_CHANGE_PROCESS:
        return Object.assign({}, state, action.status);
      case REPLACE_FLIGHT:
        if (!action.flight) return state;
        state.flightList[action.index] = action.flight;
        return state;
      case SAVE_X_PRODUCTS:
        const _xProduct = state.xProduct;
        _xProduct.products = [];
        _xProduct.xSoProducts = action.soProduct || {};
        _xProduct.hotelProduct = action.htProduct || [];
        _xProduct.trainPro = action.trainPro || [];
        action.products.forEach(productItem => {
          if (productItem.value === 0) return;
          _xProduct.products.push(productItem);
        });
        if (!_xProduct.products || !_xProduct.products.length)
          _xProduct.flightProductId = '';
        return Object.assign({}, state, {
          xProduct: _xProduct,
        });

      case SAVE_PSG_FLIGHT:
        return Object.assign({}, state, {
          selectPsg: action.selectedPsg,
          selectFlight: action.selectedFlight,
        });

      case SAVE_MU_TYPE:
        return Object.assign({}, state, {
          muRefundType: action.muRefundType,
          muRefundReason: action.muRefundReason,
          qtReason: action.qtReason,
        });

      case SAVE_MU_FILE:
        return Object.assign({}, state, {
          muFileList: action.muFileList,
        });

      case SAVE_DOOR_PRODUCTS:
        return Object.assign({}, state, {
          selectDoorList: action.selectDoorList,
        });
      case SAVE_HU_TYPE:
        return Object.assign({}, state, {
          huRefundType: action.huRefundType,
          huRefundReason: action.huRefundReason,
          beizhu: action.beizhu,
        });
      case SAVE_HU_FILE:
        return Object.assign({}, state, {
          muFileList: action.huFileList,
        });
      case SAVE_AI_PRAMAS:
        return Object.assign({}, state, action.data);
      default:
        return state;
    }
  } catch (error) {
    console.log('接口异常');
    return state;
  }
}

// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/modules/edorsedApply.js



// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/modules/edorsedApply.js